<template>
  <div id="session" @error="errorHandler" v-if="sessionId">
    <OpenTokPublisher
      v-if="canStream"
      :session="session"
      :membersList="membersList"
      :isStartStopSessionInProgress="isStartStopSessionInProgress"
      :isRecording="isRecording"
      :isSetupClosed="isSetupClosed"
      :opts="getStreamingOptions()"
      :logoUrl="logoUrl"
      @error="errorHandler"
      @stop="$emit('stop')"
      @publisherCreated="publisherCreated"
      @toggleRecording="$emit('toggleRecording')"
      @audioOutputDeviceSelectedEvent="audioOutputDeviceSelectedEvent"
    />
    <div id="subscriber" v-for="stream in streams" :key="stream.streamId">
      <OpenTokSubscriber
        @error="errorHandler"
        :stream="stream"
        :session="session"
        :opts="getSubscriberOptions()"
        :logoUrl="logoUrl"
        @videoElementCreated="subscriberVideoElementCreated"
      ></OpenTokSubscriber>
    </div>
  </div>
</template>

<script>
import OT from '@opentok/client';
import OpenTokPublisher from './OpenTokPublisher';
import OpenTokSubscriber from './OpenTokSubscriber';
import { mapGetters } from 'vuex';

const errorHandler = err => {
  console.error(err.message);
};

export default {
  name: 'OpenTokSession',
  components: { OpenTokPublisher, OpenTokSubscriber },
  props: {
    apiKey: {
      type: String,
      default: process.env.VUE_APP_OPENTOK_API_KEY,
    },
    sessionId: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    membersList: {
      type: Array,
      default: () => [],
    },
    isStartStopSessionInProgress: {
      type: Boolean,
    },
    isRecording: {
      type: Boolean,
    },
    isSetupClosed: {
      type: Boolean,
    },
    canStream: {
      type: Boolean,
      default: true,
    },
    logoUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      streamingProps: 'setting/streamingProps',
    }),
  },
  created() {
    this.session = OT.initSession(this.apiKey, this.sessionId);

    this.session.connect(this.token, err => {
      if (err) {
        errorHandler(err);
      }
    });

    this.session.on('streamCreated', event => {
      console.log('streamCreated: ', event);
      this.streams.push(event.stream);
    });
    this.session.on('streamDestroyed', event => {
      const idx = this.streams.indexOf(event.stream);
      if (idx > -1) {
        this.streams.splice(idx, 1);
      }
    });
  },
  data: () => ({
    streams: [],
    session: null,
    subscriberVideoElement: null,
  }),
  methods: {
    subscriberVideoElementCreated(element) {
      this.subscriberVideoElement = element;
      const device = this.streamingProps.selectedAudioOutputDevice;
      if (device) {
        this.subscriberVideoElement.setSinkId(device.deviceId);
      }
    },
    audioOutputDeviceSelectedEvent(device) {
      if (this.subscriberVideoElement) {
        this.subscriberVideoElement.setSinkId(device.deviceId);
      }
    },
    getSubscriberOptions() {
      return {
        subscribeToAudio: true,
        subscribeToVideo: true,
        fitMode: this.streamingProps.useContainMode ? 'contain' : 'cover',
        width: '100%',
        height: '100%',
        resolution: '1280x720',
        frameRate: 30,
      };
    },
    getStreamingOptions() {
      const streamingOptions = {
        name: name,
        width: '100%',
        height: '100%',
        resolution: '1280x720',
        frameRate: 30,
        // subscribeToAudio: this.streamingProps.audioInputEnabled,
        // subscribeToVideo: this.streamingProps.videoEnabled,
        publishAudio: this.streamingProps.audioInputEnabled,
        publishVideo: this.streamingProps.videoEnabled,
        fitMode: this.streamingProps.useContainMode ? 'contain' : 'cover',
        insertMode: 'append',
        disableAudioProcessing: !this.streamingProps.advancedAudioProcessing,
        audioFallbackEnabled: false,
        style: {
          buttonDisplayMode: 'off',
          nameDisplayMode: 'off',
        },
      };
      const props = this.streamingProps;
      if (this.streamingProps.videoEnabled && props.selectedVideoDevice) {
        streamingOptions.videoSource = props.videoEnabled
          ? props.selectedVideoDevice.deviceId
          : null;
      }
      if (
        this.streamingProps.audioInputEnabled &&
        props.selectedAudioInputDevice
      ) {
        streamingOptions.audioSource = props.audioInputEnabled
          ? props.selectedAudioInputDevice.deviceId
          : null;
      }
      console.log('streamingOptions=', streamingOptions);
      return streamingOptions;
    },
    errorHandler,
    publisherCreated(publisher) {
      // used to set the output device
      // if (this.streamingProps.selectedAudioOutputDevice) {
      //   publisher.on('videoElementCreated', (event) => {
      //     if (typeof event.element.sinkId !== 'undefined') {
      //       event.element.setSinkId(this.streamingProps.selectedAudioOutputDevice.deviceId)
      //         .then(() => {
      //           console.log('successfully set the audio output device');
      //         })
      //         .catch((err) => {
      //           console.error('Failed to set the audio output device ', err);
      //         });
      //     } else {
      //       console.warn('device does not support setting the audio output');
      //     }
      //   });
      // }
    },
  },
};
</script>

<style lang="scss">
#subscriber {
  width: 100%;
  height: 100%;
}
</style>
